import { style } from 'typestyle'

export const MemberShipAdWrap = style({
    // paddingTop: 6,
    position: 'relative',
    paddingLeft: 15,
    paddingRight: 15,
    cursor: 'pointer',
    paddingBottom: 15
})



// WEBPACK FOOTER //
// ./src/plugins/MemberShipAd/index.module.ts